import { HostType } from 'configs/theme'

export const formatSellmonitorPhone = (
  value?: string | null,
  hostType?: HostType
): string | null => {
  if (value == null || value === '') {
    return null
  }

  let result = value.replaceAll(' ', '').replace(/[^0-9+]/g, '')

  if (result === '') {
    return null
  }

  if (!['sellmonitor', 'mayak'].includes(hostType ?? '')) {
    return result.startsWith('+') ? result : '+' + result
  }

  if (result.startsWith('9')) {
    result = '+7' + result
  } else if (result.startsWith('8') || result.startsWith('7')) {
    result = '+7' + result.slice(1)
  } else if (result.startsWith('+8') || result.startsWith('+7') || result.startsWith('+9')) {
    result = '+7' + result.slice(2)
  } else if (!result.startsWith('+')) {
    result = '+' + result
  }

  return result
}
